module.exports = __webpack_public_path__ + "img/山药.9fe7bbe6.jpg";